
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { UseFormReturn } from 'react-hook-form';
import { RetentionPolicyFormValues } from '../schemas/retentionPolicySchema';

interface IsActiveFieldProps {
  form: UseFormReturn<RetentionPolicyFormValues>;
}

export function IsActiveField({ form }: IsActiveFieldProps) {
  return (
    <FormField
      control={form.control}
      name="is_active"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <FormLabel className="text-base">Active</FormLabel>
            <FormDescription>
              When active, this policy will be applied during retention processing
            </FormDescription>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}
